export class FlightsFormData {
    option: string;
    airportOrigin: string;
    airportDestiny: string;
    dtDeparture: Date;
    dtArrival: Date;

    isRoundTrip(): boolean {
        return this.option === 'ROUND_TRIP';
    }
}